<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>

    <md-empty-state
      v-if="!leftover.products.length && !cell"
      md-icon="whatshot"
      md-label="Нет задач по остаткам"
      md-description="Нет задач по остаткам"
    ></md-empty-state>

    <div class="md-layout">
      <div v-if="leftover.products.length || cell" class="leftovers-title">
        <span class="md-body-2">
          Корректировка остатков: {{ leftover.order_number }} ({{
            cell ? cell.message : "Ячейка не выбрана"
          }})
        </span>
      </div>

      <div
        v-if="leftover.products.length"
        class="md-layout-item leftovers-container"
      >
        <md-content class="md-layout leftovers-mobile-table">
          <div class="md-layout-item md-size-100">
            <md-table
              md-card
              class="md-scrollbar"
              :style="{
                overflow: 'auto',
                maxHeight: this.window.height - 95 + 'px',
                marginRight: 0,
                marginLeft: 0,
              }"
            >
              <md-table-row>
                <md-table-head>Продукт</md-table-head>
                <md-table-head>Кол-во</md-table-head>
                <md-table-head>Статус</md-table-head>
              </md-table-row>
              <md-table-row
                v-for="item in leftover.products"
                :key="item.article + item.size"
                v-on:select="onSelect(item)"
                v-on:click="onSelect(item)"
                slot="md-table-row"
                :class="getClass(item)"
                :ref="item.article + item.size"
              >
                <md-table-cell md-label="Продукт">
                  {{ item.name }} ({{ item.size.toUpperCase() }})
                </md-table-cell>
                <md-table-cell md-label="Количество">
                  {{ item.quantity }} | {{ item.provider_name }}
                </md-table-cell>
                <md-table-cell md-label="Статус">
                  {{ item.status }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </md-content>

        <md-content class="md-layout leftovers-table">
          <div class="md-layout-item md-size-100">
            <md-table
              md-card
              class="md-scrollbar"
              :style="{
                overflow: 'auto',
                maxHeight: this.window.height - 130 + 'px',
                marginRight: 0,
                marginLeft: 0,
              }"
            >
              <md-table-row>
                <md-table-head>Артикл</md-table-head>
                <md-table-head>Продукт</md-table-head>
                <md-table-head>Размер</md-table-head>
                <md-table-head>Количество</md-table-head>
                <md-table-head>Поставщик</md-table-head>
                <md-table-head>Статус</md-table-head>
              </md-table-row>
              <md-table-row
                v-for="item in leftover.products"
                :key="item.article + item.size"
                v-on:select="onSelect(item)"
                v-on:click="onSelect(item)"
                slot="md-table-row"
                :class="getClass(item)"
                :ref="item.article + item.size"
              >
                <md-table-cell md-label="Артикл">
                  {{ item.article }}
                </md-table-cell>
                <md-table-cell md-label="Продукт">
                  {{ item.name }}
                </md-table-cell>
                <md-table-cell md-label="Размер">{{ item.size }}</md-table-cell>
                <md-table-cell md-label="Количество">
                  {{ item.quantity }}
                </md-table-cell>
                <md-table-cell md-label="Поставщик">
                  {{ item.provider_name }}
                </md-table-cell>
                <md-table-cell md-label="Статус">
                  {{ item.status }}
                </md-table-cell>
              </md-table-row>
            </md-table>
          </div>
        </md-content>
      </div>
      <div v-if="selected" class="md-layout-item leftovers-image">
        <img
          width="100%"
          v-touch:swipe="imageSwipeHandler"
          v-on:click="imageClickHandler"
          :src="image"
          :alt="selected.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Leftovers",
    data: () => ({
      image: null,
      window: {
        width: null,
        height: null,
      },
      loading: false,
    }),
    created() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener("resize", this.handleResize);
    },
    mounted() {
      this.image = this.holder;
      this.processImage();
      this.processScroll();
    },
    watch: {
      selected() {
        this.processImage();
        this.processScroll();
      },
    },
    computed: {
      cell() {
        return this.$store.state.leftovers.cell;
      },
      selected() {
        return this.$store.state.leftovers.selected;
      },
      holder() {
        return this.$store.state.holder.item;
      },
      leftover() {
        return this.$store.state.leftovers.item;
      },
    },
    methods: {
      processScroll() {
        if (this.selected) {
          this.$refs[
            this.selected.article + this.selected.size
          ][0].$el.scrollIntoView({ behavior: "smooth" });
        }
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      getClass(item) {
        if (
          item.article === this.selected.article &&
          item.size === this.selected.size
        ) {
          return "md-primary md-has-selection md-selected-single";
        }
      },
      onSelect(item) {
        this.$store.commit("leftovers/setSelected", item);
      },
      processImage() {
        this.image = this.holder;

        const path = this.selected.images.big[0];
        new Promise((resolve, reject) => {
          const img = new Image();

          img.onload = () => resolve();

          img.onerror = () => reject();

          img.src = path;
        })
          .then(() => {
            this.image = path;
          })
          .catch((error) => {
            console.error(error);
            this.$store.commit("messages/setMessage", {
              type: "warning",
              code: "Ой вей!",
              message: "Картинка к товару не была загружена",
            });
          });
      },
      imageClickHandler() {
        this.imageSwipeHandler("right");
      },
      imageSwipeHandler(direction) {
        const index = this.selected.images.big.indexOf(this.image);

        if (direction === "right") {
          if (index - 1 >= 0) {
            this.image = this.selected.images.big[index - 1];
          } else {
            this.image = this.selected.images.big[
              this.selected.images.big.length - 1
            ];
          }
        }

        if (direction === "left") {
          if (index + 1 <= this.selected.images.big.length - 1) {
            this.image = this.selected.images.big[index + 1];
          } else {
            this.image = this.selected.images.big[0];
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .leftovers-container {
    flex: 1 1 55%;
  }

  .leftovers-table {
    @media (max-width: 960px) {
      display: none !important;
    }
  }

  .leftovers-mobile-table {
    display: none !important;
    @media (max-width: 960px) {
      display: flex !important;
    }
  }

  .leftovers-title {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    width: 100%;
  }

  .md-layout-item.leftovers-table-container {
    min-width: 75%;
    max-width: 75%;
    flex: 0 1 75%;
    @media (max-width: 460px) {
      min-width: 100%;
      max-width: 100%;
      flex: 0 1 100%;
    }
  }

  .leftovers-image {
    flex: 1 1;
    height: calc(100vh - 52px);
    overflow: hidden;
    @media (max-width: 800px) {
      height: calc(100vh - 95px);
    }

    @media (max-width: 460px) {
      display: none;
    }
  }
</style>
